import React from "react";
import Image from "../../image";
import { Link } from "../../../utils/customLink";
import { useTheme } from "../../../context/ThemeContext";

import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";
import ArrowRightBigIcon from "images/icons/arrow-right-big-icon.inline.svg";

const SimpleExperienceCard = ({
  experienceTitle,
  experienceFeaturedImage,
  fallbackImage,
  slim = false,
  targetUrl,
  titleBgCol,
  outerContainerClass
}) => {
  const { colorMode } = useTheme();
  return (
    <>
      <div className={outerContainerClass}>
        <div>
          <Image
            imageClass={`object-cover object-center w-full h-[130px] rounded-t-[5px] ${
              slim ? "sm:h-[130px]" : ""
            }`}
            image={experienceFeaturedImage}
            imageAlt={experienceTitle}
            sourceUrl={fallbackImage}
          />
        </div>

        <div
          className={`flex py-4 rounded-b-[5px] ${titleBgCol} sm:text-center text-left sm:items-center sm:justify-center justify-between sm:px-4 px-6`}
        >
          <div className="text-sm lato-regular-latin text-generic-text dark:text-gray-generic sm:text-center text-left sm:w-full w-full">
            {experienceTitle}
          </div>
          {targetUrl && (
            <Link
              to={targetUrl}
              className="sm:hidden block float-right right-0 py-4"
            >
              {colorMode === "light" ? (
                <ArrowRightBigIcon fill-black-lighter />
              ) : (
                <ArrowRightIcon stroke-gray-generic />
              )}
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default SimpleExperienceCard;

SimpleExperienceCard.defaultProps = {
  slim: false,
  titleBgCol: "h-full sm:h-14 bg-secondary-bg dark:bg-gray-dark",
  outerContainerClass: ""
};
